import { all, put, takeEvery, call, select } from "redux-saga/effects";
import {
  EMAIL_TEMPLATE_TYPES_ACTIONS,
  EMAIL_TEMPLATE_TYPES_TYPES
} from "./actions";
import { getEmailTemplateTypes as APIgetEmailTemplateTypes } from "../../services/api/emailTemplateTypes";
import { emailTemplateTypesFilters } from "./selectors";

export function* watchEmailTemplateTypesActions() {
  yield all([
    takeEvery(
      EMAIL_TEMPLATE_TYPES_TYPES.LOAD_ALL_REQUEST,
      getEmailTemplateTypes
    )
  ]);
}

function* getEmailTemplateTypes(action) {
  try {
    const filters = yield select(emailTemplateTypesFilters);
    const emailTemplateTypes = yield call(APIgetEmailTemplateTypes, filters);
    yield put(EMAIL_TEMPLATE_TYPES_ACTIONS.loadAllSuccess(emailTemplateTypes));
  } catch (e) {
    yield put(EMAIL_TEMPLATE_TYPES_ACTIONS.loadAllFailure(e));
  }
}
